/**
 * @name    trackTiming
 * @autor   Pierre Dedy
 * @type    controller
 * @desc    track timings to GA
 * @date    12.2014
 * @example category  = A string for categorizing all user timing variables into logical groups
 * @example variable  = A string to indicate the name of the action of the resource being tracked
 * @example time      = The number of milliseconds in elapsed time to report to Google Analytics
 * @example opt_label = A string that can be used to add flexibility in visualizing user timings in the reports
 */
window.dataLayer = window.dataLayer || [];
window.trackTimings = window.trackTimings || [];

var trackTiming = function(cfg) {
    this.cfg = {
        trackingType: 'user timings',
        category: 'current',
        variable: '',
        url: '',
        time: 0,
        opt_label: '',
    };

    for (var param in cfg) {
        this.cfg[param] = cfg[param];
    }

    if (this.cfg.category === 'current') {
        if (
            window.ApplicationProperties &&
            window.ApplicationProperties.get('trackingGridName')
        ) {
            this.cfg.category = ApplicationProperties.get('trackingGridName');
        } else {
            this.cfg.category = location.pathname;
        }
    }

    var inputUrl = this.cfg.url || location.href;

    if (this.cfg.variable !== '') {
        this.variable = this.cfg.variable;
    } else {
        this.variable = (window.URL && new URL(inputUrl).pathname) || inputUrl;
    }

    if (this.cfg.time !== 0) {
        this.cfg.time = Math.round(this.cfg.time);
    }

    this.time = this.cfg.time;
};

trackTiming.prototype = {
    time: 0,
    variable: '',

    /**
     *
     * @returns {boolean}
     */
    push: function() {
        if (this.time > 0) {
            window.dataLayer.push({
                event: 'userTiming',
                timingCategory: this.cfg.category,
                timingVar: this.variable,
                timingValue: this.time,
                timingLabel: this.cfg.opt_label,
            });
        }

        return true;
    },
};

var processTrackTimings = function() {
    if (!window.trackTimings.length) {
        return;
    }

    for (var index in window.trackTimings) {
        var timingConf = window.trackTimings[index];
        new trackTiming(timingConf).push();
        delete window.trackTimings[index];
    }
};

function trackTimingsForHtmlApi(name, time) {
    if (time < 0) {
        return;
    }
    window.trackTimings.push({
        variable: name,
        time: time,
    });
}

function getTimings() {
    var performance =
        window.performance ||
        window.webkitPerformance ||
        window.msPerformance ||
        window.mozPerformance;

    if (performance === undefined) {
        return false;
    }

    var timing = performance.timing;
    var api = {};

    if (timing) {
        if (api.firstPaintTime === undefined) {
            var firstPaintTime = 0;

            if (typeof timing.msFirstPaint === 'number') {
                firstPaintTime = timing.msFirstPaint - timing.navigationStart;
            } else if (performance.getEntriesByName !== undefined) {
                var firstPaintEntries = performance.getEntriesByName(
                    'first-paint'
                );
                if (firstPaintEntries.length === 1) {
                    firstPaintTime = firstPaintEntries[0].startTime;
                }
            }

            api.firstPaintTime = firstPaintTime;
        }

        if (api.firstMeaningfulPaintTime === undefined) {
            var firstMeaningfulPaintTime = 0;

            if (performance.getEntriesByName !== undefined) {
                var firstContentfulPaintEntries = performance.getEntriesByName(
                    'first-contentful-paint'
                );
                if (firstContentfulPaintEntries.length === 1) {
                    firstMeaningfulPaintTime =
                        firstContentfulPaintEntries[0].startTime;
                }
            }

            api.firstMeaningfulPaintTime = firstMeaningfulPaintTime;
        }

        // Total time from start to load
        api.loadTime = timing.loadEventEnd - timing.fetchStart;
        // Time spent constructing the DOM tree
        api.domReadyTime = timing.domComplete - timing.domInteractive;
        // Time consumed preparing the new page
        api.readyStart = timing.fetchStart - timing.navigationStart;
        // Time spent during redirection
        api.redirectTime = timing.redirectEnd - timing.redirectStart;
        // AppCache
        api.appcacheTime = timing.domainLookupStart - timing.fetchStart;
        // Time spent unloading documents
        api.unloadEventTime = timing.unloadEventEnd - timing.unloadEventStart;
        // DNS query time
        api.lookupDomainTime =
            timing.domainLookupEnd - timing.domainLookupStart;
        // TCP connection time
        api.connectTime = timing.connectEnd - timing.connectStart;
        // Time spent during the request
        api.requestTime = timing.responseEnd - timing.requestStart;
        // Request to completion of the DOM loading
        api.initDomTreeTime = timing.domInteractive - timing.responseEnd;
        api.loadEventTime = timing.loadEventEnd - timing.loadEventStart;
        api.clientLoadTime = timing.loadEventEnd - timing.responseEnd;
    }

    return api;
}

(function() {
    var initTracking = function() {
        var timingVars = getTimings();
        for (var name in timingVars) {
            var timing = timingVars[name];
            trackTimingsForHtmlApi(name, timing);
        }
    };
    if (window.addEventListener) {
        window.addEventListener('load', initTracking);
    }
})();

setInterval(processTrackTimings, 500);
